import type { Locale } from 'antd/es/locale';
import ruRUImport from 'antd/locale/ru_RU';

// Under Vite, this deep CJS subpath sometimes comes through double-wrapped as
// `{ default: Locale }` instead of `Locale` — unwrap defensively either way, otherwise
// `ConfigProvider` silently falls back to English for every built-in antd string.
const ruRU: Locale = (ruRUImport as unknown as { default?: Locale }).default ?? ruRUImport;

export function getAntdLocale(_language: string): Locale {
  return ruRU;
}
